import React from 'react';
import { connect, history } from 'umi';

import { Button, Text } from '@digitalc/dxp-ui';
import { onHistoryPush } from '@/utils/utils';
import { Clickable } from '@/components';
import useResponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';
import convertSuccess from '@/assets/images/point/convertSuccess.png';
import styles from './index.less';

const SuccessPage = props => {
  const { dxpToken } = props;
  const {
    type,
    receiver,
    PointsType,
    pointValue,
    transferor,
    sourceName,
    sourcePoints,
    destinationPoints,
    destinationName,
  } = history.location.query;
  // 响应式 hook
  useResponsive();
  const GCPI18n = useGCPI18n();
  const titleMap = {
    Transfer: GCPI18n({
      id: 'lb_transfer_sucseess',
    }),
    Conversion: GCPI18n({
      id: 'lb_conversion_sucseess',
    }),
  };
  return (
    <div className={styles.successPage}>
      <div className={styles.top}>
        <img src={convertSuccess} alt="" />
        <div className={styles.successTitle}>{titleMap[type]}</div>
      </div>
      {type === 'Conversion' && (
        <div className={styles.details}>
          <div className={styles.detailsTitle}> {GCPI18n({ id: 'lb_conversion_details' })}</div>
          <div className={styles.detailsContent}>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_converison_source' })}</div>
              <div className={styles.right}>{sourceName}</div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_converison_points' })}</div>
              <div className={styles.right}>{sourcePoints}</div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_converison_destination' })}</div>
              <div className={styles.right}>{destinationName}</div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_converison_points' })}</div>
              <div className={styles.right}>{destinationPoints}</div>
            </div>
          </div>
        </div>
      )}
      {type === 'Transfer' && (
        <div className={styles.details}>
          <div className={styles.detailsTitle}> {GCPI18n({ id: 'transfer_details' })}</div>
          <div className={styles.detailsContent}>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_point_your_number' })}</div>
              <div className={styles.right}>{transferor}</div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_point_recipient_number' })}</div>
              <div className={styles.right}>{receiver}</div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_transfer_type' })}</div>
              <div className={styles.right}>{PointsType}</div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.16rem' }}
            >
              <div className={styles.left}>{GCPI18n({ id: 'lb_point_points' })}</div>
              <div className={styles.right}>{pointValue}</div>
            </div>
          </div>
        </div>
      )}
      <div className={styles.footer}>
        <div className={styles.footerBox}>
          <div className={styles.orderSubmit}>
            <Button
              block
              type="primary"
              style={{ color: '#ffffff' }}
              onClick={() => {
                onHistoryPush('/pointshop/pointsH5');
              }}
            >
              {GCPI18n({
                id: 'lb_back_to_point_mall',
              })}
            </Button>
          </div>
        </div>
        {type === 'Conversion' && (
          <Clickable
            style={{ marginTop: dxpToken.spacingIconMd, textAlign: 'center' }}
            // className={styles.footerCancel}
            onClick={() => {
              onHistoryPush('/pointshop/pointsConversion');
            }}
          >
            <Text breakpoint="Mobile" size="ContentC14TextLink">
              {GCPI18n({
                id: 'lb_converison_continue',
              })}
            </Text>
          </Clickable>
        )}
        {type === 'Transfer' && (
          <Clickable
            style={{ marginTop: dxpToken.spacingIconMd, textAlign: 'center' }}
            // className={styles.footerCancel}
            onClick={() => {
              onHistoryPush('/pointshop/pointsTransfer');
            }}
          >
            <Text breakpoint="Mobile" size="ContentC14TextLink">
              {GCPI18n({
                id: 'lb_transfer_continue',
              })}
            </Text>
          </Clickable>
        )}
      </div>
    </div>
  );
};

export default connect(({ pointShop, loading, index }) => ({
  changeHis: pointShop.changeHis,
  pointDetail: pointShop.pointDetail,
  dxpToken: index.dxpToken,
  loading: loading.effects['pointShop/pointTransfer'] || false,
}))(SuccessPage);
